module.exports = ".no-padding {\n    padding: 0 !important;\n    margin: 0 !important;\n }\n\n .label-padding{\n    padding-right: 1.5em !important;\n }"